module.exports = __webpack_public_path__ + "static/media/drawer_home_active.c67d806d.svg";